export const coerceQueryParameter = <T = string | string[],>(
    queryParameter: T | T[]
) => (Array.isArray(queryParameter) ? queryParameter[0] : queryParameter);
